/**
 * Helps to stop click event propagation from child to parent element.
 */
const stopPropagation = (e) => {
  e.stopPropagation()
}

export default stopPropagation
